'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var SHARE_POPUP_TOGGLE_SHARE_FORM = exports.SHARE_POPUP_TOGGLE_SHARE_FORM = 'SHARE_POPUP_TOGGLE_SHARE_FORM';


//////////////////
// WEBPACK FOOTER
// ./src/client/workspace/header/utils/sharing/sharingPopupConstants.js
// module id = 785
// module chunks = 0